import { Injectable, computed, signal } from '@angular/core';
import { AdminCredentials } from '../models';

const STORAGE_KEY = 'mockingbird.admin.session';

@Injectable({
  providedIn: 'root',
})
export class AdminSessionService {
  private session = signal<AdminCredentials | null>(this.readSession());

  readonly credentials = computed(() => this.session());
  readonly isActive = computed(() => this.session() !== null);

  setSession(credentials: AdminCredentials): void {
    this.session.set(credentials);
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(credentials));
  }

  clearSession(): void {
    this.session.set(null);
    sessionStorage.removeItem(STORAGE_KEY);
  }

  private readSession(): AdminCredentials | null {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (!stored) {
      return null;
    }

    try {
      const parsed = JSON.parse(stored) as Partial<AdminCredentials>;
      if (typeof parsed.admin_email === 'string' && typeof parsed.admin_password === 'string') {
        return {
          admin_email: parsed.admin_email,
          admin_password: parsed.admin_password,
        };
      }
    } catch {
      sessionStorage.removeItem(STORAGE_KEY);
    }

    return null;
  }
}
